import { z } from "zod";

export const ConditionOperator = z.enum([">=", "==", "<"]);
export type ConditionOperator = z.infer<typeof ConditionOperator>;

export const HasItemCondition = z.object({
	type: z.literal("HasItem"),
	itemId: z.string().min(1, "Required for HasItem"),
	operator: ConditionOperator,
	value: z.number().finite(),
}).strict();

export const HasStatCondition = z.object({
	type: z.literal("HasStat"),
	statKey: z.string().min(1, "Required for HasStat"),
	operator: ConditionOperator,
	value: z.number().finite(),
}).strict();

export const HasCurrencyCondition = z.object({
	type: z.literal("HasCurrency"),
	currencyId: z.string().min(1, "Required for HasCurrency"),
	operator: ConditionOperator,
	value: z.number().finite(),
}).strict();

export const IsOnZoneCondition = z.object({
	type: z.literal("IsOnZone"),
	zoneItemId: z.string().min(1, "Required for IsOnZone"),
}).strict();

export const ConditionSchema = z.discriminatedUnion("type", [
	HasItemCondition,
	HasStatCondition,
	HasCurrencyCondition,
	IsOnZoneCondition,
]);
export type Condition = z.infer<typeof ConditionSchema>;

export type ConditionType = Condition["type"];

export const CONDITION_TYPES: readonly ConditionType[] = [
	"HasItem",
	"HasStat",
	"HasCurrency",
	"IsOnZone",
] as const;

export type ConditionFieldRef = {
	refEntity: "items" | "stats" | "currencies";
	fieldName: "itemId" | "statKey" | "currencyId" | "zoneItemId";
};

export const CONDITION_REFS: Partial<Record<ConditionType, ConditionFieldRef>> = {
	HasItem: { refEntity: "items", fieldName: "itemId" },
	HasStat: { refEntity: "stats", fieldName: "statKey" },
	HasCurrency: { refEntity: "currencies", fieldName: "currencyId" },
	IsOnZone: { refEntity: "items", fieldName: "zoneItemId" },
};
